import { createSelector } from 'reselect';

const selectPayemnt = state => state.payment;

export const selectCurrentPayment = createSelector(
  [selectPayemnt],
  payment => payment
);